import { LuSearch } from "@/Components/Icons/Icons.jsx";
export default {
  row1: [
    {
      column: "column1",

      rows: {
        row1: [
          {
            name: "exportShipmentExBondBENo",
            label: "BE No",
            component: "text-field",
            width: "50%",
            required: true,

          },
          {
            name: "PackageDetails",
            label: "Init",
            component: "backlink",
            action: "openSubDialog",
            subComponent: "ShipmentExBondInitPopUp",
            width : "20%",
            sx: {
              mt: 5,
            },
          },
          {
            name: "exportShipmentExBondBEDate",
            label: "BE Date",
            component: "dateselector",
            width: "50%",
            required: true,
          },
        ],

        row2: [
          {
            name: "exportShipmentExBondVessel",
            label: "Vessal",
            component: "text-field",
          },

          {
            name: "exportShipmentExBondVoyage",
            label: "Voyage",
            component: "text-field",
          },
        ],

        row3: [
          {
            name: "exportShipmentExBondIGMNo",
            label: "IGM No",
            width: "50%",
            component: "text-field",
          },
          {
            name: "exportShipmentExBondGMDate",
            label: "IGM Date",
            component: "dateselector",
            width: "50%",
          },
        ],

        row4: [
          {
            name: "exportShipmentExBondNoOfPackage",
            label: "No Of Pkg",
            component: "text-field",
            width: "30%",
            dataType: "int",
          },
          {
            name: "exportShipmentExBondNoOfPackageUnit",
            component: "text-field",
            width: "18%",
            icon: LuSearch,
            iconColor: "gray-400",
            disabled: true,
            type: "autocomplete",
            endpoint: "getQuantity",
            dependsOn: "exportShipmentExBondNoOfPackage",   // 👈 new property
            enableWhen: (val) => !!val
          },
          {
            name: "exportShipmentExBondNo",
            label: "Bond No",
            component: "text-field",
            width: "50%",
          },
        ],
        row5: [
          {
            name: "exportShipmentExBondDate",
            label: "Bond Date",
            component: "dateselector",
            width: "50%",
          },
          {
            name: "exportShipmentExBondWareHouse",
            label: "Warehouse",
            component: "text-field",
            width: "50%",
          },
        ],
      },
    },
  ],
};
